import { Redirect } from 'react-router-dom';

import { useLoggedInUserRoles } from '~/components/Auth';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { RedirectToPortalContinue } from '~/scenes/PortalViews/components/RedirectToPortalContinue';
import { isMobileBrowser } from '~/utils/helper';

export const RedirectAuthenticatedLogin = () => {
  const loggedInUserRoles = useLoggedInUserRoles();
  const isSuperUser = loggedInUserRoles.includes('ADMIN');

  if (isSuperUser) {
    // Redirect to Application Console
    window.location.replace('d/html/index.html');
    return <LoadingView />;
  }

  if (isMobileBrowser()) {
    return <Redirect to={'/mobile'} />;
  }

  return <RedirectToPortalContinue />;
};
